import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  APPLY_SELECTED_TEMPLATES_REQUEST_2_0,
  APPLY_SELECTED_TEMPLATES_SUCCESS_2_0,
  APPLY_SELECTED_TEMPLATES_FAILURE_2_0,
  APPLY_SELECTED_TEMPLATES_LOADING_2_0,
  APPLY_SELECTED_TEMPLATES_RESET_2_0,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isTemplateApply: false,
};

export const applySelectedTherapyPlanningTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case APPLY_SELECTED_TEMPLATES_SUCCESS_2_0: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTemplateApply: true,
      };
    }

    case APPLY_SELECTED_TEMPLATES_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTemplateApply: false,
      };
    case APPLY_SELECTED_TEMPLATES_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case APPLY_SELECTED_TEMPLATES_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
